import { ReactNode, useEffect } from 'react';

import { Button, CircularProgress } from '@mui/material';

import { ConditionalTooltip } from 'shared/components/Conditional';

interface ButtonWithLoaderProps {
  // Button
  variant?: 'text' | 'contained' | 'outlined';
  color?: 'inherit' | 'secondary' | 'primary' | 'success' | 'error' | 'info' | 'warning';
  isLoading: boolean;
  label: string;
  loaderSize?: number;
  type?: 'button' | 'submit' | 'reset' | undefined;
  sx?: any;
  disabled?: boolean;
  onClick?: () => void;
  startIcon?: ReactNode;
  tooltip?: string;
}
function ButtonWithLoader({
  variant = 'contained',
  color = 'secondary',
  isLoading,
  label,
  loaderSize = 16,
  type = 'button',
  sx,
  disabled,
  onClick,
  startIcon,
  tooltip,
}: ButtonWithLoaderProps) {
  useEffect(() => {}, [disabled, isLoading]);

  return (
    <div className="form__action">
      <ConditionalTooltip title={tooltip}>
        <Button
          variant={variant}
          color={color}
          type={type}
          disabled={disabled || isLoading}
          sx={sx}
          onClick={onClick}
          startIcon={startIcon}
        >
          { label }
        </Button>
      </ConditionalTooltip>
      {
        isLoading
          ? <CircularProgress className="form__action--loader" size={loaderSize} color={color} />
          : null
      }
    </div>
  );
}

export default ButtonWithLoader;
